import type TagInformation from '~/types/tagInformations'
import type TagTypeKey from '~/types/tagTypeKey'

export type SubGenreCategoryKey = 'genre' | 'mood' | 'attribute'
export type SubGenreCategoryTagType = Extract<
  TagTypeKey,
  'subgenre' | 'mood' | 'artist_kind' | 'format'
>
export type SubGenreCategoryOrderedTagType = Record<
  SubGenreCategoryKey,
  SubGenreCategoryTagType[]
>
export interface SubGenreCategoryData {
  icon: string
  tags: TagInformation[]
}

export type CategoryType = 'preferences' | 'music-type'

// N.B: the order of the keys will dictate the order the subcategories are displayed in
// cf. computed 'subGenreCategories'
export const CATEGORIZED_SUBGENRES_FILTERS: SubGenreCategoryOrderedTagType = {
  genre: ['subgenre'],
  mood: ['mood'],
  attribute: ['artist_kind', 'format'],
}
export const formatCategoryName = (rawCategoryName: string): string =>
  rawCategoryName.charAt(0).toUpperCase() + rawCategoryName.slice(1)
